// @ts-nocheck
import { PUBLIC_URL } from '../config/env';
import { canonicalSubject } from './progressStatus';

const FAMILY_FRIENDLY_SUBJECTS = new Set(['Literacy', 'Math', 'Success Skills', 'Social Studies']);
const FAMILY_DESCRIPTIONS_CSV = 'Missouri Standards Aligned - Family Facing.csv';

function parseCsv(text) {
  const rows = [];
  let row = [];
  let field = '';
  let insideQuotes = false;
  for (let index = 0; index < text.length; index += 1) {
    const character = text[index];
    if (insideQuotes) {
      if (character === '"' && text[index + 1] === '"') {
        field += '"';
        index += 1;
      } else if (character === '"') {
        insideQuotes = false;
      } else {
        field += character;
      }
    } else if (character === '"') {
      insideQuotes = true;
    } else if (character === ',') {
      row.push(field);
      field = '';
    } else if (character === '\n') {
      row.push(field.replace(/\r$/, ''));
      rows.push(row);
      row = [];
      field = '';
    } else {
      field += character;
    }
  }
  if (field || row.length) {
    row.push(field.replace(/\r$/, ''));
    rows.push(row);
  }
  return rows;
}

export function indexFamilyDescriptions(csvText) {
  const [headerRow, ...dataRows] = parseCsv(csvText);
  const headers = (headerRow || []).map((header) => header.replace(/^\uFEFF/, '').replace(/\s+/g, ' ').trim());
  const columnIndex = (name) => headers.indexOf(name);
  const requiredColumns = {
    subject: columnIndex('Subject'),
    code: columnIndex('MLS Code'),
    domain: columnIndex('Family Friendly Domain Explanation'),
    strand: columnIndex('Family Friendly Strand Explanation'),
    standard: columnIndex('Learning Outcome (Family Friendly Language)'),
  };
  if (Object.values(requiredColumns).some((index) => index < 0)) {
    throw new Error('Family-facing standards CSV is missing required description columns.');
  }
  const videoIndex = columnIndex('Video Link');
  const activityIndex = columnIndex('At Home Activity');
  const gradeIndex = columnIndex('Grade Level');
  const domainNameIndex = headers.findIndex((h) => /^domain\s*des/i.test(h));
  const strandNameIndex = headers.findIndex((h) => /^strand\s*desc/i.test(h));
  const standardDescIndex = headers.findIndex((h) => /^standard\s*desc/i.test(h));

  return dataRows.reduce((descriptions, row) => {
    const subject = canonicalSubject(row[requiredColumns.subject]);
    const code = String(row[requiredColumns.code] || '').trim();
    if (!code || !FAMILY_FRIENDLY_SUBJECTS.has(subject)) return descriptions;
    const entry = {
      subject,
      domain: String(row[requiredColumns.domain] || '').trim(),
      strand: String(row[requiredColumns.strand] || '').trim(),
      standard: String(row[requiredColumns.standard] || '').trim(),
      video: videoIndex >= 0 ? String(row[videoIndex] || '').trim() : '',
      activity: activityIndex >= 0 ? String(row[activityIndex] || '').trim() : '',
    };
    if (gradeIndex >= 0 && row[gradeIndex] !== undefined) {
      entry.grade = String(row[gradeIndex] || '').trim();
    }
    if (domainNameIndex >= 0 && row[domainNameIndex] !== undefined) {
      entry.domainName = String(row[domainNameIndex] || '').trim();
    }
    if (strandNameIndex >= 0 && row[strandNameIndex] !== undefined) {
      entry.strandName = String(row[strandNameIndex] || '').trim();
    }
    if (standardDescIndex >= 0 && row[standardDescIndex] !== undefined) {
      entry.standardDescription = String(row[standardDescIndex] || '').trim();
    }
    descriptions[code] = entry;
    return descriptions;
  }, {});
}

export async function fetchFamilyDescriptions() {
  const response = await fetch(`${PUBLIC_URL}/${encodeURIComponent(FAMILY_DESCRIPTIONS_CSV)}`);
  if (!response.ok) throw new Error(`Failed to load family-friendly descriptions (${response.status}).`);
  return indexFamilyDescriptions(await response.text());
}
